export enum MeetTypes {
  GOOGLE = 'google',
  OUTLOOK = 'outlook',
  HUBSPOT = 'hubspot',
  INFUSIONSOFT = 'infusionsoft',
}
